import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DEFAULT_MAP_CONT_STATE } from "./constants";
import { IMapContentState } from "./interfaces";
import { IStoreItem, IWasmStoreGeometry, IWasmStoreMarker } from "~/wasm/store/interfaces";

// todor - changeId - nechat treba do 1000, pak zase od nuly?
const mapSlice = createSlice({
	name: "mapContent",
	initialState: DEFAULT_MAP_CONT_STATE,
	reducers: {
		addMarker: (state: IMapContentState, action: PayloadAction<IWasmStoreMarker>) => {
			state.changeId++;
			state.affectedType = "marker";
			state.affectedIds = [action.payload.id];
			state.markers.push(action.payload);
		},
		removeMarker: (state: IMapContentState, action: PayloadAction<IStoreItem["id"]>) => {
			state.changeId++;
			state.affectedType = "marker";
			state.affectedIds = [action.payload];
			state.markers = state.markers.filter(item => item.id !== action.payload);
		},
		updateMarker: (state: IMapContentState, action: PayloadAction<{ id: IStoreItem["id"]; data: Partial<IWasmStoreMarker>; }>) => {
			state.changeId++;
			state.affectedType = "marker";
			state.affectedIds = [action.payload.id];

			const markerData = state.markers.filter(item => item.id === action.payload.id)[0];

			if (markerData) {
				Object.assign(markerData, action.payload.data);
			}
		},
		addGeometry: (state: IMapContentState, action: PayloadAction<IWasmStoreGeometry>) => {
			state.changeId++;
			state.affectedType = "geometry";
			state.affectedIds = [action.payload.id];
			state.geometries.push(action.payload);
		},
		removeGeometry: (state: IMapContentState, action: PayloadAction<IStoreItem["id"]>) => {
			state.changeId++;
			state.affectedType = "geometry";
			state.affectedIds = [action.payload];
			state.geometries = state.geometries.filter(item => item.id !== action.payload);
		},
		updateGeometry: (state: IMapContentState, action: PayloadAction<{ id: IStoreItem["id"]; data: Partial<IWasmStoreGeometry>; }>) => {
			state.changeId++;
			state.affectedType = "geometry";
			state.affectedIds = [action.payload.id];

			const geometryData = state.geometries.filter(item => item.id === action.payload.id)[0];

			if (geometryData) {
				Object.assign(geometryData, action.payload.data);
			}
		},
	},
});

// dle "duck" metodiky jsou akce pojmenovane exporty a reducer default export
export const { addMarker, removeMarker, updateMarker, addGeometry, removeGeometry, updateGeometry } = mapSlice.actions;
export default mapSlice.reducer;
